import { Component, OnInit, ViewChild } from '@angular/core';
import { DataBindingDirective } from '@progress/kendo-angular-grid';
import { MessageService } from '@progress/kendo-angular-l10n';
import { process } from '@progress/kendo-data-query';
import { Locker } from 'src/app/models/locker.model';
import { CustomMessagesService } from 'src/app/services/custom-messages.service';
import { lockers } from 'src/app/resources/lockers';
import { images } from 'src/app/resources/images';
import { DialogContentBase, DialogRef, DialogService } from "@progress/kendo-angular-dialog";
import { HorizontalAlign } from '@progress/kendo-angular-layout';
import { SharingService } from 'src/app/services/sharing.service';
import { BaseHttpResponse } from 'src/app/models/base-http-response';
import { ApiService } from 'src/app/services/http/api.service';
import { Modulo } from 'src/app/models/modulo.model';
import { Router } from '@angular/router';
import { Compartimento, CompartimentoEstado } from 'src/app/models/compartimento.model';

@Component({
    selector: 'app-lockers-details-component',
    templateUrl: './lockers-details.component.html'
})
export class LockersDetailsComponent extends DialogContentBase implements OnInit {
    @ViewChild(DataBindingDirective) dataBinding?: DataBindingDirective;
    public hAlign: HorizontalAlign = "start";
    public gridData: Locker[] = lockers;
    public gridView: any[] = [];
    public locker: Locker = {
        id: 0,
        nomeLocal: '',
        refLocal: 0,
        refModeloArmario: 0,
        nomeModeloArmario: '',
        numeroDeSerie: '',
        nome: '',
        dimensaoTotal: '',
        numeroUtilDeCacifos: '',
        modulos: []
    };
    public mySelection: string[] = [];
    public modulos: Modulo[] = [];
    public customMsgService: CustomMessagesService;

    constructor(private router: Router, private sharingService: SharingService, public msgService: MessageService, private dialogService: DialogService, public override dialog: DialogRef, private api: ApiService) {
        super(dialog);
        this.customMsgService = this.msgService as CustomMessagesService;
    }

    backHome() {
        this.router.navigate(['/lockers']);
    }

    load() {
        this.api
            .getRequest<BaseHttpResponse<Modulo[]>>("Armario/GetConfiguracaoModulosArmario?idArmario=" + this.locker?.id)
            .then((data) => {
                this.modulos = data.value;
            })
            .catch((err) => { });
    }

    public ngOnInit(): void {
        this.locker = this.sharingService.sharingValue;
        this.load();
        this.gridView = this.gridData;
    }

    public onFilter(inputValue: string): void {
        this.gridView = process(this.gridData, {
            filter: {
                logic: 'or',
                filters: [
                    {
                        field: this.getField,
                        operator: 'contains',
                        value: inputValue
                    }
                ]
            }
        }).data;
        this.dataBinding ? this.dataBinding.skip = 0 : null;
    }

    public getField = (args: Locker) => {
        return `${args.nome}_$`;
    }

    public photoURL(dataItem: any): string {
        const code: string = dataItem.imgId + dataItem.gender;
        const image: any = images;
        return image[code];
    }

    public flagURL(dataItem: any): string {
        const code: string = dataItem.country;
        const image: any = images;
        return image[code];
    }


    public alertaCor(c: Compartimento): string {

        if (c.hmi == true) {
            return 'box hmibox'
        } else if (c.compartimentoEstado.ocupado == true) {
            return 'box redbox'
        } else if (c.compartimentoEstado.bloqueado == true) {
            return 'box greybox'
        } else {
            return '';
        }
    }

    hmiVisible(c: Compartimento): string {
        if (c.hmi == true) {
            return "";
        }
        else {
            return c.nome;
        }
    }


    estadoBtn(c: Compartimento): string {
        if (c.hmi == true) {
            return "width: 60px; height: 20px;";
        }
        else {
            return "width: 20px; height: 20px;";
        }
    }

    public getColor(l: Locker, c: Compartimento): string {

        if (c.compartimentoEstado.bloqueado == true || c.hmi == true) {
            return 'box greybox'
        }
        else if (c.compartimentoEstado.ocupado == true) {
            return 'box redbox'
        }
        else {
            return 'box standardbox';
        }
    }


}